// besturimz-website/src/components/ScrollToTop.js
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '')
      const scrollToSection = () => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return true
        }
        return false
      }

      if (!scrollToSection()) {
        const timer = setTimeout(scrollToSection, 100)
        return () => clearTimeout(timer)
      }
      return undefined
    }

    window.scrollTo(0, 0)
    return undefined
  }, [pathname, hash])

  return null
}

export default ScrollToTop
